import script from "./JackDanielsView.vue?vue&type=script&setup=true&lang=js"
export * from "./JackDanielsView.vue?vue&type=script&setup=true&lang=js"

import "./JackDanielsView.vue?vue&type=style&index=0&id=174187b4&lang=css"

const __exports__ = script;

export default __exports__